import React, { useEffect, useState } from 'react';
import { useFormContext } from '../Form';
import CountrySelect from '../CountrySelect';
import { vat } from '@afosto/catalog/api/Vat';
import fetchCountries from '@afosto/utils/fetchCountries';

const VatCountrySelect = ({ name, onChange, ...props }) => {
  const [countries, setCountries] = useState([]);
  const formContext = useFormContext();
  const { setValue } = formContext ?? {};

  useEffect(() => {
    const fetchVatCountries = async () => {
      try {
        const response = await vat.getVatList();
        const { data = [] } = response;
        const availableCountries = [...new Set(data.map(({ country }) => country))];
        const allCountries = await fetchCountries();
        const filteredCountries = allCountries.filter(country =>
          availableCountries.includes(country.value),
        );

        setCountries(filteredCountries);
      } catch (err) {
        setCountries([]);
      }
    };

    fetchVatCountries();
  }, []);

  const handleOnChange = (ev, newValue) => {
    if (formContext && !onChange) {
      setValue(name, newValue?.value);
      return;
    }

    if (onChange) {
      onChange(ev, newValue?.value);
    }
  };

  return <CountrySelect {...props} name={name} options={countries} onChange={handleOnChange} />;
};

VatCountrySelect.propTypes = CountrySelect.propTypes;

VatCountrySelect.defaultProps = CountrySelect.defaultProps;

export default VatCountrySelect;
